export class ComponentUrls {
    public static readonly HubUrl: string = '/hubs/notification';
    public static readonly QsViewPersonId: string = 'view-p';
    public static readonly QsToken: string = 'token';
    public static readonly QsImpersonatedPersonId: string = 'impersonate-p';
    public static readonly QsImpersonateAsPrincipal: string = 'impersonate-as-p';
    public static readonly QsImpersonatedRoles: string = 'impersonate-r';
}

export class SignalRGroups {
    public static readonly Job: string = ':Internal:JOB';
    public static readonly Room: string = ':Internal:ROOM';
    public static readonly FlightsList = ':Internal:FLIGHTS_LIST';
}